import { AnimatePresence, motion } from "motion/react";
import { FC, useEffect, useRef, useState } from "react";
import { Icons, Toggle, useClickOutside, useTranslation } from "rujira.ui";
import { AutoClaimerStatusMenu } from "../AutoClaimerStatusMenu";
import { TRADE_AUTO_CLAIM_ENABLED } from "../../features";

export const OrdersSettings: FC<{
  only: boolean;
  setOnly: (v: boolean) => void;
}> = ({ only, setOnly }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useClickOutside(() => setOpen(false));
  const trigger = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      setOpen(false);
      trigger.current?.focus();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <div className="orders-settings" ref={ref}>
      <button
        ref={trigger}
        type="button"
        className="orders-settings__trigger"
        aria-expanded={open}
        aria-label={t("settings")}
        onClick={() => setOpen((v) => !v)}>
        <Icons.Gear className="w-2 h-2" />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            className="orders-settings__menu"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}>
            {TRADE_AUTO_CLAIM_ENABLED && <AutoClaimerStatusMenu />}
            <Toggle
              className="toggle--xs"
              checked={only}
              onChange={() => setOnly(!only)}
              labelOff={t("showThisPairOnly")}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
